/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_FORM_SPLIT_COMPONENTS_CHOOSER
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted AI choice selection modal from BroadcastForm.tsx.
 */

import React from "react";

interface BroadcastChooserModalProps {
  chooserItems: any[];
  chooserAddOthers: boolean;
  setChooserAddOthers: (val: boolean) => void;
  onCancel: () => void;
  onApply: (index: number, addOthers: boolean) => void;
}

const BroadcastChooserModal: React.FC<BroadcastChooserModalProps> = ({
  chooserItems,
  chooserAddOthers,
  setChooserAddOthers,
  onCancel,
  onApply,
}) => {
  return (
    <div className="modal d-block" tabIndex={-1} role="dialog" aria-modal="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Choose an item to apply</h5>
            <button type="button" className="btn-close" onClick={onCancel}></button>
          </div>
          <div className="modal-body">
            <div className="list-group">
              {chooserItems.map((it: any, i: number) => (
                <label key={i} className="list-group-item list-group-item-action d-flex align-items-center gap-2">
                  <input type="radio" name="ai-choice" value={i} defaultChecked={i === 0} />
                  <div className="d-flex flex-column">
                    <span className="fw-semibold">
                      {it.title || it.partNumber || it.model || "(Untitled)"}
                    </span>
                    <span className="text-muted small">
                      {[it.manufacturer, it.partNumber].filter(Boolean).join(" · ")}
                    </span>
                  </div>
                </label>
              ))}
            </div>
            <div className="form-check mt-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="ai-add-others"
                checked={chooserAddOthers}
                onChange={(e) => setChooserAddOthers(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="ai-add-others">
                Also add remaining items as new rows
              </label>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-cancel-figma" onClick={onCancel}>
              <span>× Cancel</span>
            </button>
            <button
              type="button"
              className="btn-black"
              onClick={() => {
                const selected = (document.querySelector('input[name="ai-choice"]:checked') as HTMLInputElement);
                onApply(selected ? Number(selected.value) : 0, chooserAddOthers);
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadcastChooserModal;
